<div>
    {{#if leftButtons}}
        <div class='btn-group'>
            {{#each leftButtons}}
                <button id='{{id}}' class='btn btn-sm {{class}} {{#if disabled}} disabled{{/if}}'
                    {{#if tooltip}}data-toggle="tooltip" data-placement="top" title="" data-original-title="{{tooltip}}"{{/if}}
                >
                    <i class='{{icon}}'></i>
                </button>
            {{/each}}
        </div>
    {{/if}}
    {{#if centerButtons}}
        <div class='btn-group'>
            {{#each centerButtons}}
                <button id='{{id}}' class='btn btn-sm {{class}} {{#if disabled}} disabled{{/if}}'
                    {{#if tooltip}}data-toggle="tooltip" data-placement="top" title="" data-original-title="{{tooltip}}"{{/if}}
                >
                    <i class='{{icon}}'></i>
                </button>
            {{/each}}
        </div>
    {{/if}}
    {{#if rightButtons}}
        <div class='btn-group'>
            {{#each rightButtons}}
                <button id='{{id}}' class='btn btn-sm {{class}} {{#if disabled}} disabled{{/if}}'
                    {{#if tooltip}}data-toggle="tooltip" data-placement="top" title="" data-original-title="{{tooltip}}"{{/if}}
                >
                    <i class='{{icon}}'></i>
                </button>
            {{/each}}
        </div>
    {{/if}}
</div>
<span>{{{text}}}</span>
